import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './Button';

export const Header: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <h1 className="text-xl font-bold text-gray-900 lg:text-2xl">
              Hilton Auto Tyres LTD
            </h1>
          </div>
          <div className="flex items-center space-x-2 sm:space-x-4">
            {user && (
              <>
                <span className="text-xs sm:text-sm text-gray-700 hidden sm:inline">
                  Welcome, <span className="font-medium">{user.username}</span>
                </span>
                <Button variant="secondary" size="sm" onClick={logout}>
                  Logout
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

